export default "__VITE_ASSET__DERw9wP1__"